export default {
  methods: {
    // 选择数据后返回到之前页面处理选择数据的公用方法（解决微信环境不支持router.replace的问题）
    selectedBack(key) {
      const dataStr = sessionStorage.getItem(key)
      if (dataStr) {
        let data = dataStr
        try {
          data = JSON.parse(dataStr)
        } catch {
          console.log('error')
        }
        return data
      }
      return false
    },
    // 选择数据后，返回上一页面，并且在sessionStorage中暂存选择的数据
    routerBack(key, data) {
      if (data) {
        sessionStorage.setItem(key, JSON.stringify(data))
      }
      this.$router.back()
    }
  }
}
